import { useNavigate } from "react-router-dom";
import "./css/BottomNavbar.css";

export default function BottomNavbar({ currentPage = "home", lang = "en" }) {
  const navigate = useNavigate();

  // Translations
  const t = {
    en: {
      home: "Home",
      find: "Find",
      add: "Add",
      favorites: "Favorites",
      settings: "Settings",
    },
    ar: {
      home: "الرئيسية",
      find: "اكتشف",
      add: "أضف",
      favorites: "المفضلة",
      settings: "الإعدادات",
    },
  }[lang];

  const navItems = [
    { id: "home", icon: "bx-home", label: t.home },
    { id: "find", icon: "bx-hard-hat", label: t.find },
    { id: "add", icon: "bx-plus-circle", label: t.add },
    { id: "favorites", icon: "bx-heart", label: t.favorites },
    { id: "settings", icon: "bx-cog", label: t.settings },
  ];

  const handleNavClick = (itemId) => {
    switch (itemId) {
      case "home":
        navigate("/dashboard");
        break;
            case "find":
              navigate("/find-contractors");
              break;
      case "add":
        navigate("/add-work");
        break;
      case "favorites":
        navigate("/favorite-contractors");
        break;
      case "settings":
        navigate("/settings");
        break;
      default:
        break;
    }
  };

  return (
    <div className="bottom-navbar" dir={lang === "ar" ? "rtl" : "ltr"}>
      {navItems.map((item) => (
        <button
          key={item.id}
          className={`nav-item ${currentPage === item.id ? "active" : ""}`}
          onClick={() => handleNavClick(item.id)}
        >
          <i className={`bx ${item.icon}`}></i>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </div>
  );
}
